export default __webpack_public_path__ + "static/media/ukazka.1161b636.wmv";